__turbopack_context__.v({
  "container": "info-page-module__MAPi5W__container",
  "header": "info-page-module__MAPi5W__header",
  "paragraph": "info-page-module__MAPi5W__paragraph",
});
